module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comment",
      toString: function () {
        return this.url;
      }
    }